export default "__VITE_ASSET__e$YK0oUH__"